import React, { useState } from 'react';
import styled from 'styled-components';
import { MainLayout, InnerLayout } from '../styles/Layouts';
import { Title } from '../Components/Ui/Title';
import EmailIcon from '@material-ui/icons/Email';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { ContactItem } from '../Components/Contact/ContactItem';
import { Button } from '../Components/Ui/Button';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState({
    submitting: false,
    succeeded: false,
    errors: [],
  });

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus({ submitting: true, succeeded: false, errors: [] });

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_key: process.env.REACT_APP_WEB3FORMS,
          name: formData.name,
          email: formData.email,
          message: formData.message,
          subject: 'New Contact Form Submission - Portfolio',
        }),
      });

      const data = await response.json();

      if (data.success) {
        setStatus({ submitting: false, succeeded: true, errors: [] });
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus({
          submitting: false,
          succeeded: false,
          errors: ['Failed to send message. Please try again.'],
        });
      }
    } catch (error) {
      setStatus({
        submitting: false,
        succeeded: false,
        errors: ['Network error. Please check your connection and try again.'],
      });
    }
  };

  if (status.succeeded) {
    return (
      <MainLayout>
        <Title title={'Contact'} span={'Contact'} />
        <ContactPageStyled>
          <InnerLayout className={'contact-section'}>
            <div className='success-message'>
              <h3>Thank you for contacting me!</h3>
              <p>
                I have received your message and will get back to you shortly.
              </p>
              <p>
                You can also reach me directly at: juanmarcelotech@gmail.com
              </p>
              <button
                className='back-button'
                onClick={() =>
                  setStatus({ submitting: false, succeeded: false, errors: [] })
                }
              >
                Send Another Message
              </button>
            </div>
          </InnerLayout>
        </ContactPageStyled>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <Title title={'Contact'} span={'Contact'} />
      <ContactPageStyled>
        <InnerLayout className={'contact-section'}>
          <div className='left-content'>
            <div className='contact-title'>
              <h4>Get In Touch</h4>
            </div>
            <form className='form' onSubmit={handleSubmit}>
              <div className='form-field'>
                <label htmlFor='name'>Enter your name*</label>
                <input
                  type='text'
                  id='name'
                  name='name'
                  className='name'
                  required
                  placeholder='Your full name'
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              <div className='form-field'>
                <label htmlFor='email'>Enter your email*</label>
                <input
                  type='email'
                  id='email'
                  name='email'
                  className='email'
                  required
                  placeholder='your.email@example.com'
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className='form-field'>
                <label htmlFor='message'>Enter your Message*</label>
                <textarea
                  name='message'
                  className='message'
                  id='message'
                  cols='30'
                  rows='10'
                  required
                  placeholder='Tell me about your project or how I can help you...'
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className='form-field f-button'>
                <Button
                  title={status.submitting ? 'Sending...' : 'Send Email'}
                  disabled={status.submitting}
                />
              </div>
              {status.errors && status.errors.length > 0 && (
                <div className='form-errors'>
                  <p>Please fix the following errors:</p>
                  <ul>
                    {status.errors.map((error, index) => (
                      <li key={index}>{error}</li>
                    ))}
                  </ul>
                </div>
              )}
            </form>
          </div>
          <div className='right-content'>
            <ContactItem
              email={true}
              title={'Email'}
              icon={<EmailIcon />}
              text={'juanmarcelotech@gmail.com'}
            />
            <ContactItem
              title={'Address'}
              icon={<LocationOnIcon />}
              text={'Buenos Aires, Argentina.'}
            />
          </div>
        </InnerLayout>
      </ContactPageStyled>
    </MainLayout>
  );
};

const ContactPageStyled = styled.section`
  .contact-section {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 2rem;
    @media screen and (max-width: 978px) {
      grid-template-columns: repeat(1, 1fr);
      .f-button {
        margin-bottom: 3rem;
      }
    }
    .right-content {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      @media screen and (max-width: 502px) {
        width: 100%;
      }
    }
    .contact-title {
      h4 {
        color: var(--white-color);
        padding: 1rem 0;
        font-size: 1.8rem;
      }
    }
    .success-message {
      text-align: center;
      padding: 3rem 1rem;
      background: rgba(255, 255, 255, 0.05);
      border-radius: 10px;
      border: 1px solid var(--border-color);

      h3 {
        color: var(--white-color);
        font-size: 2rem;
        margin-bottom: 1rem;
      }

      p {
        color: var(--white-color);
        font-size: 1.1rem;
        margin-bottom: 0.5rem;
        opacity: 0.9;
      }

      .back-button {
        margin-top: 2rem;
        padding: 12px 24px;
        background: var(--primary-color);
        color: var(--white-color);
        border: none;
        border-radius: 5px;
        cursor: pointer;
        font-size: 1rem;
        transition: all 0.3s ease;

        &:hover {
          background: var(--primary-color-2);
          transform: translateY(-2px);
        }
      }
    }
    .form {
      width: 100%;
      @media screen and (max-width: 502px) {
        width: 100%;
      }
      .form-field {
        margin-top: 2rem;
        position: relative;
        width: 100%;
        @media screen and (max-width: 786px) {
          width: 100%;
        }
        label {
          position: absolute;
          left: 20px;
          top: -19px;
          display: inline-block;
          background-color: var(--background-dark-color);
          padding: 0 0.5rem;
          color: inherit;
        }
        input {
          border: 1px solid var(--border-color);
          outline: none;
          background: transparent;
          height: 50px;
          padding: 0 15px;
          width: 100%;
          color: inherit;
          @media screen and (max-width: 786px) {
            width: 100%;
            margin-left: auto;
            margin-right: auto;
          }
          &::placeholder {
            color: rgba(255, 255, 255, 0.5);
          }
        }
        textarea {
          resize: none;
          background-color: transparent;
          border: 1px solid var(--border-color);
          outline: none;
          color: inherit;
          width: 100%;
          height: 200px;
          padding: 0.8rem 1rem;
          @media screen and (max-width: 786px) {
            width: 100%;
            margin-left: auto;
            margin-right: auto;
          }
          &::placeholder {
            color: rgba(255, 255, 255, 0.5);
          }
        }
      }
      .form-errors {
        margin-top: 1rem;
        padding: 1rem;
        background: rgba(255, 0, 0, 0.1);
        border: 1px solid rgba(255, 0, 0, 0.3);
        border-radius: 5px;

        p {
          color: #ff6b6b;
          margin-bottom: 0.5rem;
          font-weight: bold;
        }

        ul {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            color: #ff6b6b;
            margin-bottom: 0.25rem;
            font-size: 0.9rem;
          }
        }
      }
    }
  }
`;
